module.exports = __webpack_public_path__ + "static/media/amazon-original.19741bfb.svg";